import { createAsyncThunk, createSelector } from "@reduxjs/toolkit"
import type { AppDispatch, RootState } from "./store"
// import { memoize } from "proxy-memoize"

// const createProxySelectorHook = () => {
//   const useProxySelector = <TReturnType>(
//     fn: (state: RootState) => TReturnType,
//     deps?: DependencyList,
//   ): TReturnType => {
//     return useAppSelector(useCallback(memoize(fn), deps || []))
//   }
//   return useProxySelector
// }
//
// export const useProxySelector = createProxySelectorHook()

export const createAppSelector = createSelector.withTypes<RootState>()
export const createAppAsyncThunk = createAsyncThunk.withTypes<{
  state: RootState
  dispatch: AppDispatch
}>()

export const createSelectorFn = <T>(fn: (state: RootState) => T) => fn
